var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":_vm.fileInfo.fileName,"visible":_vm.visible,"size":"100%","direction":"rtl","destroy-on-close":true,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event},"opened":_vm.opened}},[_c('div',{ref:"output",staticStyle:{"height":"100%"},attrs:{"id":"output"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }